import axios from 'axios'
import { PDFDocument } from 'pdf-lib'
import { apiUrl } from '../../../../config'
import authenticationStore from '../../../../stores/authenticationStore'
import fileStore from '../../../../stores/fileStore'

export const PdfEsignUltil = {
  async getBlobPdfFormatOfOfficeFile(fileId) {
    try {
      // Step 1: Fetch the DOCX file from your API using axios
      const response = await axios.get(
        `${apiUrl}/api/v1/upload/attachments/${fileId}`,
        {
          responseType: 'blob', // This ensures the file is downloaded in binary format
          headers: {
            Accept: 'application/json, text/plain, */*',
            Authorization: `Bearer ${
              JSON.parse(authenticationStore.appToken).access_token
            }`,
          },
        }
      )
      const file = new File([response.data], `shuypreviewsigndocument.pdf`, {
        type: 'application/pdf',
      })
      return URL.createObjectURL(file)
    } catch (error) {
      // console.error('Error converting DOCX to PDF:', error)
      throw error // Re-throw the error so the caller knows something went wrong
    }
  },
  getScaleUnitFromNewDims(pngImage, targetWidth, targetHeight) {
    const scaleX = targetWidth / pngImage.width
    const scaleY = targetHeight / pngImage.height
    return Math.min(scaleX, scaleY)
  },
  async mergePdfs(pdfFileIds, fileName) {
    try {
      // Initialize a new PDF document that will contain all merged pages
      const mergedPdfDoc = await PDFDocument.create()

      // For each PDF file ID, fetch the file and extract its pages
      for (const fileId of pdfFileIds) {
        // Get the PDF file as blob
        const pdfUrl = await this.getBlobPdfFormatOfOfficeFile(fileId)
        const pdfBytes = await fetch(pdfUrl).then(res => res.arrayBuffer())

        // Load the PDF document
        const pdfDoc = await PDFDocument.load(pdfBytes)

        // Get all pages from the PDF
        const pages = pdfDoc.getPages()

        // Copy each page into the merged document
        for (let i = 0; i < pages.length; i++) {
          const [copiedPage] = await mergedPdfDoc.copyPages(pdfDoc, [i])
          mergedPdfDoc.addPage(copiedPage)
        }
      }

      // Save the merged document
      const mergedPdfBytes = await mergedPdfDoc.save()

      // Create a Blob from the merged PDF bytes
      const mergedPdfBlob = new Blob([mergedPdfBytes], {
        type: 'application/pdf',
      })

      // Create a filename for the merged document
      const mergedFileName = fileName
        ? `${fileName}.pdf`
        : `Bieu_quyet_${new Date().getTime()}.pdf`

      // Prepare the form data for uploading the file
      const formData = new FormData()
      formData.append('file', mergedPdfBlob, mergedFileName)

      // Upload the merged file to the server
      const { data } = await fileStore.uploadFile(formData)

      // Return the file ID and file name of the uploaded merged PDF
      return {
        file_id: data.file_id,
        file_name: data.file_name,
      }
    } catch (error) {
      console.error('Error merging PDF files:', error)
      throw error
    }
  },

  // Optional helper function to merge the current PDF with the newly generated one
  async mergeCurrentPdfWithGenerated(currentPdfFileId, generatedPdfFileId, fileName) {
    try {
      const mergeResult = await this.mergePdfs(
        [currentPdfFileId, generatedPdfFileId],
        fileName
      )
      return mergeResult
    } catch (error) {
      console.error('Error merging current PDF with generated PDF:', error)
      throw error
    }
  },
}
